/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ActivateAccountRouteImport } from './routes/activate-account'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as KioskIndexRouteImport } from './routes/kiosk/index'
import { Route as SignaturesSignatureIdRouteImport } from './routes/signatures/$signatureId'
import { Route as AuthenticatedWorkshopSettingsRouteImport } from './routes/_authenticated/workshop-settings'
import { Route as AuthenticatedWorkshopRouteImport } from './routes/_authenticated/workshop'
import { Route as AuthenticatedWarehouseRouteImport } from './routes/_authenticated/warehouse'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedScheduleRouteImport } from './routes/_authenticated/schedule'
import { Route as AuthenticatedRolesRouteImport } from './routes/_authenticated/roles'
import { Route as AuthenticatedPlanningRouteImport } from './routes/_authenticated/planning'
import { Route as AuthenticatedHandoffRouteImport } from './routes/_authenticated/handoff'
import { Route as AuthenticatedCommunicationTemplatesRouteImport } from './routes/_authenticated/communication-templates'
import { Route as AuthenticatedCapacityRouteImport } from './routes/_authenticated/capacity'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedSlutkalkylerIndexRouteImport } from './routes/_authenticated/slutkalkyler/index'
import { Route as AuthenticatedManageWorkshopsIndexRouteImport } from './routes/_authenticated/manage-workshops/index'
import { Route as AuthenticatedUsersUserIdRouteImport } from './routes/_authenticated/users/$userId'
import { Route as AuthenticatedSlutkalkylerWorkOrderIdRouteImport } from './routes/_authenticated/slutkalkyler/$workOrderId'
import { Route as AuthenticatedManageWorkshopsWorkshopIdRouteImport } from './routes/_authenticated/manage-workshops/$workshopId'
import { Route as AuthenticatedDealershipDealershipIdRouteImport } from './routes/_authenticated/dealership/$dealershipId'
import { Route as AuthenticatedCommunicationTemplateTemplateIdRouteImport } from './routes/_authenticated/communication-template/$templateId'
import { Route as AuthenticateddeveloperDesignSystemRouteImport } from './routes/_authenticated/(developer)/design-system'
import { Route as AuthenticateddeveloperDebugRouteImport } from './routes/_authenticated/(developer)/debug'
import { Route as AuthenticatedWorkshopWorkorderWorkOrderIdRouteImport } from './routes/_authenticated/workshop/workorder/$workOrderId'
import { Route as AuthenticatedWorkshopDayScheduleUserIdRouteImport } from './routes/_authenticated/workshop/day-schedule/$userId'
import { Route as AuthenticatedWorkshopSettingsWorkorderWorkOrderIdRouteImport } from './routes/_authenticated/workshop-settings/workorder/$workOrderId'
import { Route as AuthenticatedWarehouseWorkorderWorkOrderIdRouteImport } from './routes/_authenticated/warehouse/workorder/$workOrderId'
import { Route as AuthenticatedSchedulePlanAbsenceWorkshopRouteImport } from './routes/_authenticated/schedule/plan-absence/$workshop'
import { Route as AuthenticatedScheduleDayScheduleUserIdRouteImport } from './routes/_authenticated/schedule/day-schedule/$userId'
import { Route as AuthenticatedPlanningWorkorderWorkOrderIdRouteImport } from './routes/_authenticated/planning/workorder/$workOrderId'
import { Route as AuthenticatedHandoffWorkorderWorkOrderIdRouteImport } from './routes/_authenticated/handoff/workorder/$workOrderId'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivateAccountRoute = ActivateAccountRouteImport.update({
  id: '/activate-account',
  path: '/activate-account',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LoginRoute,
} as any)
const KioskIndexRoute = KioskIndexRouteImport.update({
  id: '/kiosk/',
  path: '/kiosk/',
  getParentRoute: () => rootRouteImport,
} as any)
const SignaturesSignatureIdRoute = SignaturesSignatureIdRouteImport.update({
  id: '/signatures/$signatureId',
  path: '/signatures/$signatureId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedWorkshopSettingsRoute =
  AuthenticatedWorkshopSettingsRouteImport.update({
    id: '/workshop-settings',
    path: '/workshop-settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWorkshopRoute = AuthenticatedWorkshopRouteImport.update({
  id: '/workshop',
  path: '/workshop',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedWarehouseRoute = AuthenticatedWarehouseRouteImport.update({
  id: '/warehouse',
  path: '/warehouse',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedScheduleRoute = AuthenticatedScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRolesRoute = AuthenticatedRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPlanningRoute = AuthenticatedPlanningRouteImport.update({
  id: '/planning',
  path: '/planning',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHandoffRoute = AuthenticatedHandoffRouteImport.update({
  id: '/handoff',
  path: '/handoff',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCommunicationTemplatesRoute =
  AuthenticatedCommunicationTemplatesRouteImport.update({
    id: '/communication-templates',
    path: '/communication-templates',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCapacityRoute = AuthenticatedCapacityRouteImport.update({
  id: '/capacity',
  path: '/capacity',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSlutkalkylerIndexRoute =
  AuthenticatedSlutkalkylerIndexRouteImport.update({
    id: '/slutkalkyler/',
    path: '/slutkalkyler/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedManageWorkshopsIndexRoute =
  AuthenticatedManageWorkshopsIndexRouteImport.update({
    id: '/manage-workshops/',
    path: '/manage-workshops/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersUserIdRoute =
  AuthenticatedUsersUserIdRouteImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSlutkalkylerWorkOrderIdRoute =
  AuthenticatedSlutkalkylerWorkOrderIdRouteImport.update({
    id: '/slutkalkyler/$workOrderId',
    path: '/slutkalkyler/$workOrderId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedManageWorkshopsWorkshopIdRoute =
  AuthenticatedManageWorkshopsWorkshopIdRouteImport.update({
    id: '/manage-workshops/$workshopId',
    path: '/manage-workshops/$workshopId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDealershipDealershipIdRoute =
  AuthenticatedDealershipDealershipIdRouteImport.update({
    id: '/dealership/$dealershipId',
    path: '/dealership/$dealershipId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCommunicationTemplateTemplateIdRoute =
  AuthenticatedCommunicationTemplateTemplateIdRouteImport.update({
    id: '/communication-template/$templateId',
    path: '/communication-template/$templateId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticateddeveloperDesignSystemRoute =
  AuthenticateddeveloperDesignSystemRouteImport.update({
    id: '/(developer)/design-system',
    path: '/design-system',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticateddeveloperDebugRoute =
  AuthenticateddeveloperDebugRouteImport.update({
    id: '/(developer)/debug',
    path: '/debug',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWorkshopWorkorderWorkOrderIdRoute =
  AuthenticatedWorkshopWorkorderWorkOrderIdRouteImport.update({
    id: '/workorder/$workOrderId',
    path: '/workorder/$workOrderId',
    getParentRoute: () => AuthenticatedWorkshopRoute,
  } as any)
const AuthenticatedWorkshopDayScheduleUserIdRoute =
  AuthenticatedWorkshopDayScheduleUserIdRouteImport.update({
    id: '/day-schedule/$userId',
    path: '/day-schedule/$userId',
    getParentRoute: () => AuthenticatedWorkshopRoute,
  } as any)
const AuthenticatedWorkshopSettingsWorkorderWorkOrderIdRoute =
  AuthenticatedWorkshopSettingsWorkorderWorkOrderIdRouteImport.update({
    id: '/workorder/$workOrderId',
    path: '/workorder/$workOrderId',
    getParentRoute: () => AuthenticatedWorkshopSettingsRoute,
  } as any)
const AuthenticatedWarehouseWorkorderWorkOrderIdRoute =
  AuthenticatedWarehouseWorkorderWorkOrderIdRouteImport.update({
    id: '/workorder/$workOrderId',
    path: '/workorder/$workOrderId',
    getParentRoute: () => AuthenticatedWarehouseRoute,
  } as any)
const AuthenticatedSchedulePlanAbsenceWorkshopRoute =
  AuthenticatedSchedulePlanAbsenceWorkshopRouteImport.update({
    id: '/plan-absence/$workshop',
    path: '/plan-absence/$workshop',
    getParentRoute: () => AuthenticatedScheduleRoute,
  } as any)
const AuthenticatedScheduleDayScheduleUserIdRoute =
  AuthenticatedScheduleDayScheduleUserIdRouteImport.update({
    id: '/day-schedule/$userId',
    path: '/day-schedule/$userId',
    getParentRoute: () => AuthenticatedScheduleRoute,
  } as any)
const AuthenticatedPlanningWorkorderWorkOrderIdRoute =
  AuthenticatedPlanningWorkorderWorkOrderIdRouteImport.update({
    id: '/workorder/$workOrderId',
    path: '/workorder/$workOrderId',
    getParentRoute: () => AuthenticatedPlanningRoute,
  } as any)
const AuthenticatedHandoffWorkorderWorkOrderIdRoute =
  AuthenticatedHandoffWorkorderWorkOrderIdRouteImport.update({
    id: '/workorder/$workOrderId',
    path: '/workorder/$workOrderId',
    getParentRoute: () => AuthenticatedHandoffRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activate-account': typeof ActivateAccountRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRouteWithChildren
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/capacity': typeof AuthenticatedCapacityRoute
  '/communication-templates': typeof AuthenticatedCommunicationTemplatesRoute
  '/handoff': typeof AuthenticatedHandoffRouteWithChildren
  '/planning': typeof AuthenticatedPlanningRouteWithChildren
  '/roles': typeof AuthenticatedRolesRoute
  '/schedule': typeof AuthenticatedScheduleRouteWithChildren
  '/settings': typeof AuthenticatedSettingsRoute
  '/warehouse': typeof AuthenticatedWarehouseRouteWithChildren
  '/workshop': typeof AuthenticatedWorkshopRouteWithChildren
  '/workshop-settings': typeof AuthenticatedWorkshopSettingsRouteWithChildren
  '/signatures/$signatureId': typeof SignaturesSignatureIdRoute
  '/kiosk/': typeof KioskIndexRoute
  '/login/': typeof LoginIndexRoute
  '/debug': typeof AuthenticateddeveloperDebugRoute
  '/design-system': typeof AuthenticateddeveloperDesignSystemRoute
  '/communication-template/$templateId': typeof AuthenticatedCommunicationTemplateTemplateIdRoute
  '/dealership/$dealershipId': typeof AuthenticatedDealershipDealershipIdRoute
  '/manage-workshops/$workshopId': typeof AuthenticatedManageWorkshopsWorkshopIdRoute
  '/slutkalkyler/$workOrderId': typeof AuthenticatedSlutkalkylerWorkOrderIdRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/manage-workshops/': typeof AuthenticatedManageWorkshopsIndexRoute
  '/slutkalkyler/': typeof AuthenticatedSlutkalkylerIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/handoff/workorder/$workOrderId': typeof AuthenticatedHandoffWorkorderWorkOrderIdRoute
  '/planning/workorder/$workOrderId': typeof AuthenticatedPlanningWorkorderWorkOrderIdRoute
  '/schedule/day-schedule/$userId': typeof AuthenticatedScheduleDayScheduleUserIdRoute
  '/schedule/plan-absence/$workshop': typeof AuthenticatedSchedulePlanAbsenceWorkshopRoute
  '/warehouse/workorder/$workOrderId': typeof AuthenticatedWarehouseWorkorderWorkOrderIdRoute
  '/workshop-settings/workorder/$workOrderId': typeof AuthenticatedWorkshopSettingsWorkorderWorkOrderIdRoute
  '/workshop/day-schedule/$userId': typeof AuthenticatedWorkshopDayScheduleUserIdRoute
  '/workshop/workorder/$workOrderId': typeof AuthenticatedWorkshopWorkorderWorkOrderIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activate-account': typeof ActivateAccountRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/capacity': typeof AuthenticatedCapacityRoute
  '/communication-templates': typeof AuthenticatedCommunicationTemplatesRoute
  '/handoff': typeof AuthenticatedHandoffRouteWithChildren
  '/planning': typeof AuthenticatedPlanningRouteWithChildren
  '/roles': typeof AuthenticatedRolesRoute
  '/schedule': typeof AuthenticatedScheduleRouteWithChildren
  '/settings': typeof AuthenticatedSettingsRoute
  '/warehouse': typeof AuthenticatedWarehouseRouteWithChildren
  '/workshop': typeof AuthenticatedWorkshopRouteWithChildren
  '/workshop-settings': typeof AuthenticatedWorkshopSettingsRouteWithChildren
  '/signatures/$signatureId': typeof SignaturesSignatureIdRoute
  '/kiosk': typeof KioskIndexRoute
  '/login': typeof LoginIndexRoute
  '/debug': typeof AuthenticateddeveloperDebugRoute
  '/design-system': typeof AuthenticateddeveloperDesignSystemRoute
  '/communication-template/$templateId': typeof AuthenticatedCommunicationTemplateTemplateIdRoute
  '/dealership/$dealershipId': typeof AuthenticatedDealershipDealershipIdRoute
  '/manage-workshops/$workshopId': typeof AuthenticatedManageWorkshopsWorkshopIdRoute
  '/slutkalkyler/$workOrderId': typeof AuthenticatedSlutkalkylerWorkOrderIdRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/manage-workshops': typeof AuthenticatedManageWorkshopsIndexRoute
  '/slutkalkyler': typeof AuthenticatedSlutkalkylerIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/handoff/workorder/$workOrderId': typeof AuthenticatedHandoffWorkorderWorkOrderIdRoute
  '/planning/workorder/$workOrderId': typeof AuthenticatedPlanningWorkorderWorkOrderIdRoute
  '/schedule/day-schedule/$userId': typeof AuthenticatedScheduleDayScheduleUserIdRoute
  '/schedule/plan-absence/$workshop': typeof AuthenticatedSchedulePlanAbsenceWorkshopRoute
  '/warehouse/workorder/$workOrderId': typeof AuthenticatedWarehouseWorkorderWorkOrderIdRoute
  '/workshop-settings/workorder/$workOrderId': typeof AuthenticatedWorkshopSettingsWorkorderWorkOrderIdRoute
  '/workshop/day-schedule/$userId': typeof AuthenticatedWorkshopDayScheduleUserIdRoute
  '/workshop/workorder/$workOrderId': typeof AuthenticatedWorkshopWorkorderWorkOrderIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/activate-account': typeof ActivateAccountRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRouteWithChildren
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_authenticated/capacity': typeof AuthenticatedCapacityRoute
  '/_authenticated/communication-templates': typeof AuthenticatedCommunicationTemplatesRoute
  '/_authenticated/handoff': typeof AuthenticatedHandoffRouteWithChildren
  '/_authenticated/planning': typeof AuthenticatedPlanningRouteWithChildren
  '/_authenticated/roles': typeof AuthenticatedRolesRoute
  '/_authenticated/schedule': typeof AuthenticatedScheduleRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/warehouse': typeof AuthenticatedWarehouseRouteWithChildren
  '/_authenticated/workshop': typeof AuthenticatedWorkshopRouteWithChildren
  '/_authenticated/workshop-settings': typeof AuthenticatedWorkshopSettingsRouteWithChildren
  '/signatures/$signatureId': typeof SignaturesSignatureIdRoute
  '/kiosk/': typeof KioskIndexRoute
  '/login/': typeof LoginIndexRoute
  '/_authenticated/(developer)/debug': typeof AuthenticateddeveloperDebugRoute
  '/_authenticated/(developer)/design-system': typeof AuthenticateddeveloperDesignSystemRoute
  '/_authenticated/communication-template/$templateId': typeof AuthenticatedCommunicationTemplateTemplateIdRoute
  '/_authenticated/dealership/$dealershipId': typeof AuthenticatedDealershipDealershipIdRoute
  '/_authenticated/manage-workshops/$workshopId': typeof AuthenticatedManageWorkshopsWorkshopIdRoute
  '/_authenticated/slutkalkyler/$workOrderId': typeof AuthenticatedSlutkalkylerWorkOrderIdRoute
  '/_authenticated/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/_authenticated/manage-workshops/': typeof AuthenticatedManageWorkshopsIndexRoute
  '/_authenticated/slutkalkyler/': typeof AuthenticatedSlutkalkylerIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/handoff/workorder/$workOrderId': typeof AuthenticatedHandoffWorkorderWorkOrderIdRoute
  '/_authenticated/planning/workorder/$workOrderId': typeof AuthenticatedPlanningWorkorderWorkOrderIdRoute
  '/_authenticated/schedule/day-schedule/$userId': typeof AuthenticatedScheduleDayScheduleUserIdRoute
  '/_authenticated/schedule/plan-absence/$workshop': typeof AuthenticatedSchedulePlanAbsenceWorkshopRoute
  '/_authenticated/warehouse/workorder/$workOrderId': typeof AuthenticatedWarehouseWorkorderWorkOrderIdRoute
  '/_authenticated/workshop-settings/workorder/$workOrderId': typeof AuthenticatedWorkshopSettingsWorkorderWorkOrderIdRoute
  '/_authenticated/workshop/day-schedule/$userId': typeof AuthenticatedWorkshopDayScheduleUserIdRoute
  '/_authenticated/workshop/workorder/$workOrderId': typeof AuthenticatedWorkshopWorkorderWorkOrderIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activate-account'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/capacity'
    | '/communication-templates'
    | '/handoff'
    | '/planning'
    | '/roles'
    | '/schedule'
    | '/settings'
    | '/warehouse'
    | '/workshop'
    | '/workshop-settings'
    | '/signatures/$signatureId'
    | '/kiosk/'
    | '/login/'
    | '/debug'
    | '/design-system'
    | '/communication-template/$templateId'
    | '/dealership/$dealershipId'
    | '/manage-workshops/$workshopId'
    | '/slutkalkyler/$workOrderId'
    | '/users/$userId'
    | '/manage-workshops/'
    | '/slutkalkyler/'
    | '/users/'
    | '/handoff/workorder/$workOrderId'
    | '/planning/workorder/$workOrderId'
    | '/schedule/day-schedule/$userId'
    | '/schedule/plan-absence/$workshop'
    | '/warehouse/workorder/$workOrderId'
    | '/workshop-settings/workorder/$workOrderId'
    | '/workshop/day-schedule/$userId'
    | '/workshop/workorder/$workOrderId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activate-account'
    | '/forgot-password'
    | '/onboarding'
    | '/reset-password'
    | '/capacity'
    | '/communication-templates'
    | '/handoff'
    | '/planning'
    | '/roles'
    | '/schedule'
    | '/settings'
    | '/warehouse'
    | '/workshop'
    | '/workshop-settings'
    | '/signatures/$signatureId'
    | '/kiosk'
    | '/login'
    | '/debug'
    | '/design-system'
    | '/communication-template/$templateId'
    | '/dealership/$dealershipId'
    | '/manage-workshops/$workshopId'
    | '/slutkalkyler/$workOrderId'
    | '/users/$userId'
    | '/manage-workshops'
    | '/slutkalkyler'
    | '/users'
    | '/handoff/workorder/$workOrderId'
    | '/planning/workorder/$workOrderId'
    | '/schedule/day-schedule/$userId'
    | '/schedule/plan-absence/$workshop'
    | '/warehouse/workorder/$workOrderId'
    | '/workshop-settings/workorder/$workOrderId'
    | '/workshop/day-schedule/$userId'
    | '/workshop/workorder/$workOrderId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/activate-account'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/_authenticated/capacity'
    | '/_authenticated/communication-templates'
    | '/_authenticated/handoff'
    | '/_authenticated/planning'
    | '/_authenticated/roles'
    | '/_authenticated/schedule'
    | '/_authenticated/settings'
    | '/_authenticated/warehouse'
    | '/_authenticated/workshop'
    | '/_authenticated/workshop-settings'
    | '/signatures/$signatureId'
    | '/kiosk/'
    | '/login/'
    | '/_authenticated/(developer)/debug'
    | '/_authenticated/(developer)/design-system'
    | '/_authenticated/communication-template/$templateId'
    | '/_authenticated/dealership/$dealershipId'
    | '/_authenticated/manage-workshops/$workshopId'
    | '/_authenticated/slutkalkyler/$workOrderId'
    | '/_authenticated/users/$userId'
    | '/_authenticated/manage-workshops/'
    | '/_authenticated/slutkalkyler/'
    | '/_authenticated/users/'
    | '/_authenticated/handoff/workorder/$workOrderId'
    | '/_authenticated/planning/workorder/$workOrderId'
    | '/_authenticated/schedule/day-schedule/$userId'
    | '/_authenticated/schedule/plan-absence/$workshop'
    | '/_authenticated/warehouse/workorder/$workOrderId'
    | '/_authenticated/workshop-settings/workorder/$workOrderId'
    | '/_authenticated/workshop/day-schedule/$userId'
    | '/_authenticated/workshop/workorder/$workOrderId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ActivateAccountRoute: typeof ActivateAccountRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRouteWithChildren
  OnboardingRoute: typeof OnboardingRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignaturesSignatureIdRoute: typeof SignaturesSignatureIdRoute
  KioskIndexRoute: typeof KioskIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activate-account': {
      id: '/activate-account'
      path: '/activate-account'
      fullPath: '/activate-account'
      preLoaderRoute: typeof ActivateAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof LoginRoute
    }
    '/kiosk/': {
      id: '/kiosk/'
      path: '/kiosk'
      fullPath: '/kiosk/'
      preLoaderRoute: typeof KioskIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signatures/$signatureId': {
      id: '/signatures/$signatureId'
      path: '/signatures/$signatureId'
      fullPath: '/signatures/$signatureId'
      preLoaderRoute: typeof SignaturesSignatureIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/workshop-settings': {
      id: '/_authenticated/workshop-settings'
      path: '/workshop-settings'
      fullPath: '/workshop-settings'
      preLoaderRoute: typeof AuthenticatedWorkshopSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/workshop': {
      id: '/_authenticated/workshop'
      path: '/workshop'
      fullPath: '/workshop'
      preLoaderRoute: typeof AuthenticatedWorkshopRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/warehouse': {
      id: '/_authenticated/warehouse'
      path: '/warehouse'
      fullPath: '/warehouse'
      preLoaderRoute: typeof AuthenticatedWarehouseRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/schedule': {
      id: '/_authenticated/schedule'
      path: '/schedule'
      fullPath: '/schedule'
      preLoaderRoute: typeof AuthenticatedScheduleRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/roles': {
      id: '/_authenticated/roles'
      path: '/roles'
      fullPath: '/roles'
      preLoaderRoute: typeof AuthenticatedRolesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/planning': {
      id: '/_authenticated/planning'
      path: '/planning'
      fullPath: '/planning'
      preLoaderRoute: typeof AuthenticatedPlanningRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/handoff': {
      id: '/_authenticated/handoff'
      path: '/handoff'
      fullPath: '/handoff'
      preLoaderRoute: typeof AuthenticatedHandoffRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/communication-templates': {
      id: '/_authenticated/communication-templates'
      path: '/communication-templates'
      fullPath: '/communication-templates'
      preLoaderRoute: typeof AuthenticatedCommunicationTemplatesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/capacity': {
      id: '/_authenticated/capacity'
      path: '/capacity'
      fullPath: '/capacity'
      preLoaderRoute: typeof AuthenticatedCapacityRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/slutkalkyler/': {
      id: '/_authenticated/slutkalkyler/'
      path: '/slutkalkyler'
      fullPath: '/slutkalkyler/'
      preLoaderRoute: typeof AuthenticatedSlutkalkylerIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/manage-workshops/': {
      id: '/_authenticated/manage-workshops/'
      path: '/manage-workshops'
      fullPath: '/manage-workshops/'
      preLoaderRoute: typeof AuthenticatedManageWorkshopsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/$userId': {
      id: '/_authenticated/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AuthenticatedUsersUserIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/slutkalkyler/$workOrderId': {
      id: '/_authenticated/slutkalkyler/$workOrderId'
      path: '/slutkalkyler/$workOrderId'
      fullPath: '/slutkalkyler/$workOrderId'
      preLoaderRoute: typeof AuthenticatedSlutkalkylerWorkOrderIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/manage-workshops/$workshopId': {
      id: '/_authenticated/manage-workshops/$workshopId'
      path: '/manage-workshops/$workshopId'
      fullPath: '/manage-workshops/$workshopId'
      preLoaderRoute: typeof AuthenticatedManageWorkshopsWorkshopIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dealership/$dealershipId': {
      id: '/_authenticated/dealership/$dealershipId'
      path: '/dealership/$dealershipId'
      fullPath: '/dealership/$dealershipId'
      preLoaderRoute: typeof AuthenticatedDealershipDealershipIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/communication-template/$templateId': {
      id: '/_authenticated/communication-template/$templateId'
      path: '/communication-template/$templateId'
      fullPath: '/communication-template/$templateId'
      preLoaderRoute: typeof AuthenticatedCommunicationTemplateTemplateIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/(developer)/design-system': {
      id: '/_authenticated/(developer)/design-system'
      path: '/design-system'
      fullPath: '/design-system'
      preLoaderRoute: typeof AuthenticateddeveloperDesignSystemRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/(developer)/debug': {
      id: '/_authenticated/(developer)/debug'
      path: '/debug'
      fullPath: '/debug'
      preLoaderRoute: typeof AuthenticateddeveloperDebugRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/workshop/workorder/$workOrderId': {
      id: '/_authenticated/workshop/workorder/$workOrderId'
      path: '/workorder/$workOrderId'
      fullPath: '/workshop/workorder/$workOrderId'
      preLoaderRoute: typeof AuthenticatedWorkshopWorkorderWorkOrderIdRouteImport
      parentRoute: typeof AuthenticatedWorkshopRoute
    }
    '/_authenticated/workshop/day-schedule/$userId': {
      id: '/_authenticated/workshop/day-schedule/$userId'
      path: '/day-schedule/$userId'
      fullPath: '/workshop/day-schedule/$userId'
      preLoaderRoute: typeof AuthenticatedWorkshopDayScheduleUserIdRouteImport
      parentRoute: typeof AuthenticatedWorkshopRoute
    }
    '/_authenticated/workshop-settings/workorder/$workOrderId': {
      id: '/_authenticated/workshop-settings/workorder/$workOrderId'
      path: '/workorder/$workOrderId'
      fullPath: '/workshop-settings/workorder/$workOrderId'
      preLoaderRoute: typeof AuthenticatedWorkshopSettingsWorkorderWorkOrderIdRouteImport
      parentRoute: typeof AuthenticatedWorkshopSettingsRoute
    }
    '/_authenticated/warehouse/workorder/$workOrderId': {
      id: '/_authenticated/warehouse/workorder/$workOrderId'
      path: '/workorder/$workOrderId'
      fullPath: '/warehouse/workorder/$workOrderId'
      preLoaderRoute: typeof AuthenticatedWarehouseWorkorderWorkOrderIdRouteImport
      parentRoute: typeof AuthenticatedWarehouseRoute
    }
    '/_authenticated/schedule/plan-absence/$workshop': {
      id: '/_authenticated/schedule/plan-absence/$workshop'
      path: '/plan-absence/$workshop'
      fullPath: '/schedule/plan-absence/$workshop'
      preLoaderRoute: typeof AuthenticatedSchedulePlanAbsenceWorkshopRouteImport
      parentRoute: typeof AuthenticatedScheduleRoute
    }
    '/_authenticated/schedule/day-schedule/$userId': {
      id: '/_authenticated/schedule/day-schedule/$userId'
      path: '/day-schedule/$userId'
      fullPath: '/schedule/day-schedule/$userId'
      preLoaderRoute: typeof AuthenticatedScheduleDayScheduleUserIdRouteImport
      parentRoute: typeof AuthenticatedScheduleRoute
    }
    '/_authenticated/planning/workorder/$workOrderId': {
      id: '/_authenticated/planning/workorder/$workOrderId'
      path: '/workorder/$workOrderId'
      fullPath: '/planning/workorder/$workOrderId'
      preLoaderRoute: typeof AuthenticatedPlanningWorkorderWorkOrderIdRouteImport
      parentRoute: typeof AuthenticatedPlanningRoute
    }
    '/_authenticated/handoff/workorder/$workOrderId': {
      id: '/_authenticated/handoff/workorder/$workOrderId'
      path: '/workorder/$workOrderId'
      fullPath: '/handoff/workorder/$workOrderId'
      preLoaderRoute: typeof AuthenticatedHandoffWorkorderWorkOrderIdRouteImport
      parentRoute: typeof AuthenticatedHandoffRoute
    }
  }
}

interface AuthenticatedHandoffRouteChildren {
  AuthenticatedHandoffWorkorderWorkOrderIdRoute: typeof AuthenticatedHandoffWorkorderWorkOrderIdRoute
}

const AuthenticatedHandoffRouteChildren: AuthenticatedHandoffRouteChildren = {
  AuthenticatedHandoffWorkorderWorkOrderIdRoute:
    AuthenticatedHandoffWorkorderWorkOrderIdRoute,
}

const AuthenticatedHandoffRouteWithChildren =
  AuthenticatedHandoffRoute._addFileChildren(AuthenticatedHandoffRouteChildren)

interface AuthenticatedPlanningRouteChildren {
  AuthenticatedPlanningWorkorderWorkOrderIdRoute: typeof AuthenticatedPlanningWorkorderWorkOrderIdRoute
}

const AuthenticatedPlanningRouteChildren: AuthenticatedPlanningRouteChildren = {
  AuthenticatedPlanningWorkorderWorkOrderIdRoute:
    AuthenticatedPlanningWorkorderWorkOrderIdRoute,
}

const AuthenticatedPlanningRouteWithChildren =
  AuthenticatedPlanningRoute._addFileChildren(
    AuthenticatedPlanningRouteChildren,
  )

interface AuthenticatedScheduleRouteChildren {
  AuthenticatedScheduleDayScheduleUserIdRoute: typeof AuthenticatedScheduleDayScheduleUserIdRoute
  AuthenticatedSchedulePlanAbsenceWorkshopRoute: typeof AuthenticatedSchedulePlanAbsenceWorkshopRoute
}

const AuthenticatedScheduleRouteChildren: AuthenticatedScheduleRouteChildren = {
  AuthenticatedScheduleDayScheduleUserIdRoute:
    AuthenticatedScheduleDayScheduleUserIdRoute,
  AuthenticatedSchedulePlanAbsenceWorkshopRoute:
    AuthenticatedSchedulePlanAbsenceWorkshopRoute,
}

const AuthenticatedScheduleRouteWithChildren =
  AuthenticatedScheduleRoute._addFileChildren(
    AuthenticatedScheduleRouteChildren,
  )

interface AuthenticatedWarehouseRouteChildren {
  AuthenticatedWarehouseWorkorderWorkOrderIdRoute: typeof AuthenticatedWarehouseWorkorderWorkOrderIdRoute
}

const AuthenticatedWarehouseRouteChildren: AuthenticatedWarehouseRouteChildren =
  {
    AuthenticatedWarehouseWorkorderWorkOrderIdRoute:
      AuthenticatedWarehouseWorkorderWorkOrderIdRoute,
  }

const AuthenticatedWarehouseRouteWithChildren =
  AuthenticatedWarehouseRoute._addFileChildren(
    AuthenticatedWarehouseRouteChildren,
  )

interface AuthenticatedWorkshopRouteChildren {
  AuthenticatedWorkshopDayScheduleUserIdRoute: typeof AuthenticatedWorkshopDayScheduleUserIdRoute
  AuthenticatedWorkshopWorkorderWorkOrderIdRoute: typeof AuthenticatedWorkshopWorkorderWorkOrderIdRoute
}

const AuthenticatedWorkshopRouteChildren: AuthenticatedWorkshopRouteChildren = {
  AuthenticatedWorkshopDayScheduleUserIdRoute:
    AuthenticatedWorkshopDayScheduleUserIdRoute,
  AuthenticatedWorkshopWorkorderWorkOrderIdRoute:
    AuthenticatedWorkshopWorkorderWorkOrderIdRoute,
}

const AuthenticatedWorkshopRouteWithChildren =
  AuthenticatedWorkshopRoute._addFileChildren(
    AuthenticatedWorkshopRouteChildren,
  )

interface AuthenticatedWorkshopSettingsRouteChildren {
  AuthenticatedWorkshopSettingsWorkorderWorkOrderIdRoute: typeof AuthenticatedWorkshopSettingsWorkorderWorkOrderIdRoute
}

const AuthenticatedWorkshopSettingsRouteChildren: AuthenticatedWorkshopSettingsRouteChildren =
  {
    AuthenticatedWorkshopSettingsWorkorderWorkOrderIdRoute:
      AuthenticatedWorkshopSettingsWorkorderWorkOrderIdRoute,
  }

const AuthenticatedWorkshopSettingsRouteWithChildren =
  AuthenticatedWorkshopSettingsRoute._addFileChildren(
    AuthenticatedWorkshopSettingsRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedCapacityRoute: typeof AuthenticatedCapacityRoute
  AuthenticatedCommunicationTemplatesRoute: typeof AuthenticatedCommunicationTemplatesRoute
  AuthenticatedHandoffRoute: typeof AuthenticatedHandoffRouteWithChildren
  AuthenticatedPlanningRoute: typeof AuthenticatedPlanningRouteWithChildren
  AuthenticatedRolesRoute: typeof AuthenticatedRolesRoute
  AuthenticatedScheduleRoute: typeof AuthenticatedScheduleRouteWithChildren
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedWarehouseRoute: typeof AuthenticatedWarehouseRouteWithChildren
  AuthenticatedWorkshopRoute: typeof AuthenticatedWorkshopRouteWithChildren
  AuthenticatedWorkshopSettingsRoute: typeof AuthenticatedWorkshopSettingsRouteWithChildren
  AuthenticateddeveloperDebugRoute: typeof AuthenticateddeveloperDebugRoute
  AuthenticateddeveloperDesignSystemRoute: typeof AuthenticateddeveloperDesignSystemRoute
  AuthenticatedCommunicationTemplateTemplateIdRoute: typeof AuthenticatedCommunicationTemplateTemplateIdRoute
  AuthenticatedDealershipDealershipIdRoute: typeof AuthenticatedDealershipDealershipIdRoute
  AuthenticatedManageWorkshopsWorkshopIdRoute: typeof AuthenticatedManageWorkshopsWorkshopIdRoute
  AuthenticatedSlutkalkylerWorkOrderIdRoute: typeof AuthenticatedSlutkalkylerWorkOrderIdRoute
  AuthenticatedUsersUserIdRoute: typeof AuthenticatedUsersUserIdRoute
  AuthenticatedManageWorkshopsIndexRoute: typeof AuthenticatedManageWorkshopsIndexRoute
  AuthenticatedSlutkalkylerIndexRoute: typeof AuthenticatedSlutkalkylerIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedCapacityRoute: AuthenticatedCapacityRoute,
  AuthenticatedCommunicationTemplatesRoute:
    AuthenticatedCommunicationTemplatesRoute,
  AuthenticatedHandoffRoute: AuthenticatedHandoffRouteWithChildren,
  AuthenticatedPlanningRoute: AuthenticatedPlanningRouteWithChildren,
  AuthenticatedRolesRoute: AuthenticatedRolesRoute,
  AuthenticatedScheduleRoute: AuthenticatedScheduleRouteWithChildren,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedWarehouseRoute: AuthenticatedWarehouseRouteWithChildren,
  AuthenticatedWorkshopRoute: AuthenticatedWorkshopRouteWithChildren,
  AuthenticatedWorkshopSettingsRoute:
    AuthenticatedWorkshopSettingsRouteWithChildren,
  AuthenticateddeveloperDebugRoute: AuthenticateddeveloperDebugRoute,
  AuthenticateddeveloperDesignSystemRoute:
    AuthenticateddeveloperDesignSystemRoute,
  AuthenticatedCommunicationTemplateTemplateIdRoute:
    AuthenticatedCommunicationTemplateTemplateIdRoute,
  AuthenticatedDealershipDealershipIdRoute:
    AuthenticatedDealershipDealershipIdRoute,
  AuthenticatedManageWorkshopsWorkshopIdRoute:
    AuthenticatedManageWorkshopsWorkshopIdRoute,
  AuthenticatedSlutkalkylerWorkOrderIdRoute:
    AuthenticatedSlutkalkylerWorkOrderIdRoute,
  AuthenticatedUsersUserIdRoute: AuthenticatedUsersUserIdRoute,
  AuthenticatedManageWorkshopsIndexRoute:
    AuthenticatedManageWorkshopsIndexRoute,
  AuthenticatedSlutkalkylerIndexRoute: AuthenticatedSlutkalkylerIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface LoginRouteChildren {
  LoginIndexRoute: typeof LoginIndexRoute
}

const LoginRouteChildren: LoginRouteChildren = {
  LoginIndexRoute: LoginIndexRoute,
}

const LoginRouteWithChildren = LoginRoute._addFileChildren(LoginRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ActivateAccountRoute: ActivateAccountRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRouteWithChildren,
  OnboardingRoute: OnboardingRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignaturesSignatureIdRoute: SignaturesSignatureIdRoute,
  KioskIndexRoute: KioskIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
